/* Soil & Spoon — custom wishlist (localStorage, no backend).
   Store: array of compact items { h:handle, t:title, i:image, p:price, u:url, v:vendor }.
   Namespaced per logged-in customer id so different accounts on a shared device stay separate. */
(function () {
  var NS = (window.SS_WISHLIST_CUSTOMER ? 'c' + window.SS_WISHLIST_CUSTOMER : 'guest');
  var KEY = 'ss_wishlist_' + NS;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list, action) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('ss-wishlist:change', { detail: { count: list.length, action: action } }));
  }

  var API = {
    all: read,
    count: function () { return read().length; },
    has: function (h) { return read().some(function (x) { return x.h === h; }); },
    toggle: function (item) {
      var list = read();
      var i = list.findIndex(function (x) { return x.h === item.h; });
      var added = i < 0;
      if (i >= 0) { list.splice(i, 1); } else { list.unshift(item); }
      write(list, added ? 'add' : 'remove');
      return added; // true = added
    },
    remove: function (h) {
      write(read().filter(function (x) { return x.h !== h; }), 'remove');
    },
    clear: function () { write([], 'clear'); },
  };
  window.SSWishlist = API;

  // Toast — bilingual, brand-styled, auto-dismiss.
  var AR = document.documentElement.lang === 'ar' || document.documentElement.getAttribute('dir') === 'rtl';
  var TOAST = AR
    ? { add: 'أُضيف إلى قائمة الرغبات', remove: 'أُزيل من قائمة الرغبات' }
    : { add: 'Added to wishlist', remove: 'Removed from wishlist' };
  var toastTimer;
  function showToast(action) {
    var msg = TOAST[action]; if (!msg) return;
    var el = document.querySelector('.ss-wl-toast');
    if (!el) { el = document.createElement('div'); el.className = 'ss-wl-toast'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); document.body.appendChild(el); }
    el.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="' + (action === 'add' ? '#EDE7DA' : 'none') + '" stroke="#EDE7DA" stroke-width="1.6"/></svg><span>' + msg + '</span>';
    el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-in'); }, 2200);
  }

  function syncButtons(root) {
    (root || document).querySelectorAll('.ss-wl-btn[data-handle]').forEach(function (b) {
      var on = API.has(b.getAttribute('data-handle'));
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = b.getAttribute(on ? 'data-label-remove' : 'data-label-add');
      if (lbl) b.setAttribute('aria-label', lbl);
      var lblEl = b.querySelector('.ss-wl-btn__label');
      if (lblEl && lbl) lblEl.textContent = lbl;
    });
  }
  function syncCount() {
    var n = API.count();
    document.querySelectorAll('.ss-wl-count').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.documentElement.classList.toggle('ss-wl-has-items', n > 0);
  }

  // Toggle via delegation so it works on dynamically added cards too.
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.ss-wl-btn');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var d = b.dataset;
    API.toggle({ h: d.handle, t: d.title, i: d.image, p: d.price, u: d.url, v: d.vendor || '', vid: d.variant || '' });
    // brief pop animation
    b.classList.remove('ss-wl-pop'); void b.offsetWidth; b.classList.add('ss-wl-pop');
  }, false);

  document.addEventListener('ss-wishlist:change', function (e) {
    syncButtons(); syncCount();
    if (e.detail && e.detail.action) showToast(e.detail.action);
  });
  document.addEventListener('DOMContentLoaded', function () { syncButtons(); syncCount(); });
  // run immediately for anything already parsed
  syncButtons(); syncCount();
})();
